import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface LessonAdminLinkState {
  lessonAdminLink: string;
}

const lessonAdminLink: Module<LessonAdminLinkState, RootState> = {
  namespaced: true,
  state: {
    lessonAdminLink: '',
  },
  mutations: {
    setValue(state: LessonAdminLinkState, value: string): void {
      state.lessonAdminLink = value;
    },
  },
};

export default lessonAdminLink;
